import { createRouter, createWebHistory } from 'vue-router'
import riskRoutes from './risk'
import supportRoutes from './support'
import { getProjectType } from '@/assets/js/common'

const routeObj = () => {
  const type = getProjectType()
  if (type === 'support') {
    return {
      history: createWebHistory(import.meta.env.VITE_APP_PUBLIC_PATH_SUPPORT),
      routes: supportRoutes
    }
  } else {
    return {
      history: createWebHistory(import.meta.env.VITE_APP_PUBLIC_PATH_RISK),
      routes: riskRoutes
    }
  }
}

const router = createRouter({
  ...routeObj(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

export default router
